import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayResponsekeys from '../../../constants/locale/key/AceHighwayResponse'

const ACEHighwayResponseTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_RESPONSE
    ])
    let responseCode = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.RESPONSE_CODE)
    let responseText = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.RESPONSE_TEXT)
    let processingDate = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.PROCESSING_DATE)
    let remarks = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.REMARKS)
    let responseDate = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.RESPONSE_DATE)
    let submittedFile = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.SUBMITTED_FILE)
    let responseFile = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.RESPONSE_FILE)
    let batchId = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.BATCH_ID)
    let batchid = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.BATCHID)

    let errorCode = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.ERROR_CODE)
    let rejectType = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.REJECT_TYPE)
    let errorDesc = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.ERROR_DESC)

    let cbsaProcessingDate = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.CBSA_PROCESSING_DATE)
    let CBPRefNo = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.CBP_REF_NO)
    let tripNo = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.TRIP_NO)
    let shipmentControlNo = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.SHIPMENT_CONTROL_NO)
    let submissionType = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.SUBMISSION_TYPE)
    let submitId = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.SUBMIT_ID)
    let methodOfSubmission = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.METHOD)

    let noOfPackage = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.NO_OF_PACKAGE)
    let entryNo = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.ENTRY_NO)
    let entryType = translate(Namespace.ACE_HIGHWAY_RESPONSE, AceHighwayResponsekeys.ENTRY_TYPE)

    return {
        responseCode,
        responseText,
        processingDate,
        remarks,
        responseDate,
        submittedFile,
        responseFile,
        batchId,
        errorCode,
        rejectType,
        errorDesc,
        cbsaProcessingDate,
        CBPRefNo,
        tripNo,
        shipmentControlNo,
        submissionType,
        submitId,
        methodOfSubmission,
        noOfPackage,
        entryNo,
        entryType,
        batchid
    }
}

export default ACEHighwayResponseTranslationText